<template>
  <a-row class="life_costs-pages-pay-unpaidList content-container" id="life_costs-pages-pay-unpaidList">
    <a-row class="container-scroll">
      <!--导航部分-->
      <section class="layout-pad-full layout-margin-bottom back-white">
        <a-breadcrumb>
          <a-breadcrumb-item>首页</a-breadcrumb-item>
          <a-breadcrumb-item>生活中心</a-breadcrumb-item>
          <a-breadcrumb-item>账单管理</a-breadcrumb-item>
        </a-breadcrumb>
      </section>
      <!--导航部分 ena-->
      <!--表格部分-->
      <section class="layout-table layout-pad-full layout-margin-bottom back-white">
        <a-table size="middle" :scroll="scroll" class="J_compensation_list_table" :columns="tableObj.columns"
          :data-source="tableObj.list" :pagination="false" :loading="tableObj.tableLoading"
          >
          <template slot="action" slot-scope="text, record">
            <router-link :to="`/pay/unpaid?custId=${record.custId}&communityId=${record.communityId}&communityCode=${record.communityCode}&communityName=${record.communityName}`">查询缴费</router-link>
            <a-divider type="vertical" />
            <router-link :to="`/pay/history?custId=${record.custId}&communityId=${record.communityId}`">缴费历史</router-link>
          </template>
        </a-table>
      </section>
      <!--表格部分 ena-->
    </a-row>
  </a-row>
</template>

<script>
import ajax from '../../lib/axios/ajax'
import { POST_PAYBILL_QUERYCOMMUNITYCUSTLIST } from '../../lib/axios/apilist'

export default {
  data() {
    // 请求地址
    let ajaxParam = {
      POST_PAYBILL_QUERYCOMMUNITYCUSTLIST: POST_PAYBILL_QUERYCOMMUNITYCUSTLIST,
    };

    //分页信息
    let pagination = {
      pageSize: 10,
      current: 1,
      defaultCurrent: 1,
      defaultPageSize: 10,
      total: 0,
      showQuickJumper: true,
      showTotal: total => `共${total}条数据`,
      showSizeChanger: true,
      pageSizeOptions: ['10', '30', '50', '100'],
      showSizeChange: (current, pageSize) => {
        this.pagination.pageSize = pageSize;
        this.pagination.current = current;
        this.$options.methods.search.bind(this)();
      },
      change: (page, pageSize) => {
        this.pagination.current = page;
        this.pagination.pageSize = pageSize;
        this.$options.methods.search.bind(this)(false);
      }
    };
    let pageData = {};
    let condition = {}
    let tableObj = {
      tableLoading: false,
      list: [],
      columns: [{
        title: '缴费客户ID',
        dataIndex: 'cId',
      }, {
        title: '真实项目ID',
        dataIndex: 'communityId',
      }, {
        title: '项目名称',
        dataIndex: 'communityName',
      }, {
        title: '客户ID',
        dataIndex: 'custId',
      }, {
        title: '客户名称',
        dataIndex: 'custName',
      }, {
        title: '操作',
        dataIndex: 'action',
        fixed: 'right',
        scopedSlots: {
          customRender: 'action'
        },
      }]
    }
    let scroll = {
      x: 1000,
    }
    return {
      pagination,
      pageData,
      condition,
      tableObj,
      scroll,
      ajaxParam,
    }
  },
  mounted() {
    //进入页面
    //cabinVue 里面所有的this 都指向当前这个vue 实例
    //vue 更多使用方法请查看vue官方文档
    this.$nextTick(function () {
      //nextTick 用于当data数据改变,触发vue 渲染,且渲染完毕使用

    });
    this.initFunc()
  },
  //如果 不需要保存页面状态必须添加下面这个方法
  beforeDestroy: function () {
    
  },
  destroyed: function () {
    //离开页面方法
  },
  //监听属性变化，，变量必须是data里声明的
  watch: {},
  //监听属性变化，配置变量的同时也起到data声明的作用
  computed: {},
  methods: {
    // 初始化数据
    initFunc() {
      this.tableObj.tableLoading = true
      //搜索地址
      let url = this.ajaxParam.POST_PAYBILL_QUERYCOMMUNITYCUSTLIST;
      let successFunc = (res) => {
        this.tableObj.tableLoading = false
        if (res.code === "0000") {
          this.tableObj.list = res.data

        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.tableObj.tableLoading = false
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {}
      //fetch ajax提交数据
      ajax.fetch(url, requestParam, successFunc, errorFunc)
    },
  }
}
</script>

<style scoped>

</style>